module.exports = __webpack_public_path__ + "static/media/x.c3ce69cf.svg";